import './style.scss'
import React from 'react'

export interface ColorFieldProps {
    label?: React.ReactNode
    value: string
    onChange: (value: string) => void
    className?: string
}

export const ColorField: React.FC<ColorFieldProps> = ({
                                                          label, value, onChange, className = '',
                                                      }) => (
    <div className={`color-field ${className}`}>
        {label && <label className="color-field__label">{label}</label>}
        <label className="color-field__control">
            <span className="color-field__swatch" style={{ background: value }} />
            <span className="color-field__hex">{value.toUpperCase()}</span>
            <input
                type="color"
                className="color-field__native"
                value={value}
                onChange={(e) => onChange(e.target.value)}
            />
        </label>
    </div>
)

export default ColorField